import React from "react";

// const ReadOnlyRow = ({
//   isLoadingDelete,
//   contact,
//   handleEditClick,
//   handleDeleteClick,
// }) => {
//   return (
//     <tr className="hover-red bg-white ">
//       <td>{contact.id}</td>
//       <td>{contact.farmerid}</td>
//       <td>{contact.producttype}</td>
//       <td>{contact.weight}</td>
//       <td>{contact.companyname}</td>
//       <td>{contact.fullname}</td>
//       <td>{contact.daterecorded}</td>

//       <td>
//         <button
//           className=" br-pill bw0 bg-orange white hover-bg-yellow tc pa3"
//           type="button"
//           onClick={(event) => handleEditClick(event, contact)}
//         >
//           Edit
//         </button>

//         <button
//           className="ml2 br-pill bw0 bg-dark-red hover-bg-red white pa2 "
//           type="button"
//           onClick={() => handleDeleteClick(contact.id)}
//         >
//           Delete
//         </button>
//       </td>
//     </tr>
//   );
// };

//improved

const ReadOnlyRow = ({
  isLoadingDelete,
  contact,
  handleEditClick,
  handleDeleteClick,
  handleDownloadRow
}) => {
  return (
    <tr className="trrows hover-red bg-white ">
      <td className="bg-gold">{contact.id}</td>
      <td>{contact.farmerid}</td>
      <td>{contact.producttype}</td>
      <td>{contact.weight}</td>
      <td>{contact.companyname}</td>
      <td>{contact.fullname}</td>
      <td>{contact.daterecorded}</td>

      <td>

        <label className="pa4 hover-bg-transparent" onClick={(event) => handleEditClick(event, contact)}>
          <i className="fas fa-edit f2 hover-gold"></i>
          <span className="ml2"></span>
        </label>


        <label className="pa4 hover-bg-transparent" onClick={() => handleDownloadRow(contact)}>
          <i className="fas fa-download f2 hover-yellow green"></i>
          <span className="ml2"></span>
        </label>
        <label className="pa4 hover-bg-transparent" onClick={() => handleDeleteClick(contact.id)}>
          <i className="fas fa-trash f2 hover-yellow red"></i>
          <span className="ml2"></span>
        </label>
      </td>
    </tr>
  );
};

export default ReadOnlyRow;
